import { registerPlugin } from '@capacitor/core';
const FileOpener = registerPlugin('FileOpener');
export * from './definitions.js';
export { FileOpener };
//# sourceMappingURL=index.js.map